import { useContext } from 'react';
import AuthenticatedSessionContext from '../context/authenticatedUser';

export const useAuthenticatedSession = () => {
    return useContext(AuthenticatedSessionContext);
};
